/* eslint-disable @next/next/no-img-element */
"use client";

import * as React from "react";
import { Link } from "@tanstack/react-router";
import {
  IconBriefcase,
  IconBuilding,
  IconHome,
  IconUsers,
} from "@tabler/icons-react";

import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

const data = {
  navMain: [
    {
      title: "Organisations",
      url: "/organisations",
      icon: IconBuilding,
    },
    {
      title: "Venues",
      url: "/venues",
      icon: IconHome,
    },
    {
      title: "Agencies",
      url: "/agencies",
      icon: IconBriefcase,
    },
    {
      title: "Admins",
      url: "/admins",
      icon: IconUsers,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              size="lg"
              className="gap-3 bg-sidebar-accent/50 dark:bg-sidebar-accent/30 hover:bg-sidebar-accent/70 dark:hover:bg-sidebar-accent/50 rounded-lg border border-sidebar-border/50 shadow-sm transition-all duration-200 px-4 py-8 cursor-pointer"
            >
              <Link
                to="/organisations"
                className="flex items-center gap-3 w-full group"
              >
                <div className="h-10 w-10 flex items-center justify-center rounded-lg bg-primary/10 dark:bg-primary/20 group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-colors">
                  <img
                    src="/logo.png"
                    alt="Logo"
                    className="h-7 w-auto object-contain"
                  />
                </div>
                <div className="flex flex-col items-start gap-0.5 py-2">
                  <span className="text-sm font-semibold tracking-tight text-sidebar-foreground">
                    Venue Admin
                  </span>
                  <span className="text-xs text-sidebar-foreground/60 font-normal">
                    Dashboard
                  </span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
